import { useEffect, useMemo, useState } from 'react';

import 'app/pages/hosted-checkout/hosted-checkout.scss';
import 'app/pages/hosted-checkout/views/Checkout/styles.scss';
import { useTheme } from './useTheme';
import useIframe from '../../helpers/useIframe';
import { ViewState } from '../../interface';

import { useScript } from 'app/pages/frames/hooks/useScript';

function useCheckout(state: ViewState) {
  const theme = useMemo(() => useTheme(), []);
  const { entity, checkoutRequest } = state;
  const { initIframe, contentLoaded } = useIframe(state);
  const [showIntro, setShowIntro] = useState(true);
  const isDesktop = state?.device?.isDesktop;
  const isSelfHosted = checkoutRequest.type === 'PaymentLink';
  const { status, loadScript } = useScript({
    removeOnUnmount: false,
  });

  useEffect(() => {
    if (typeof window.DigitalFemsaCheckoutComponents !== 'undefined') {
      initIframe();
    }
  }, [status]);

  useEffect(() => {
    loadScript(process.env.COMPONENT_URL!);
  }, []);

  return {
    theme,
    entity,
    checkoutRequest,
    contentLoaded,
    showIntro,
    setShowIntro,
    isDesktop,
    isSelfHosted,
  };
}

export default useCheckout;
